import React from "react";
import { RiArrowDropDownLine } from "react-icons/ri";
import "../assets/css/agent/right-bar.scss";
import ProfileImg from "../assets/images/profile.png";

function RightBar() {
    return (
        <div className="right-bar">
            <div className="d-flex profile-div">
                <img
                    src={ProfileImg}
                    className="img img-fluid"
                    width="30px"
                    height="30px"
                    style={{
                        border: "1px solid #7455F6",
                        borderRadius: "50%",
                    }}
                />
                &nbsp;<p className="m-0 user-name">Agent Tool</p>
            </div>
            <div className="list">
                <div className="list-item d-flex align-items-center justify-content-between">
                    <p className="m-0">My Activity Logs</p>
                    <RiArrowDropDownLine
                        size={34}
                        className="dropdown-icon"
                    />
                </div>
                <div className="list-item d-flex align-items-center justify-content-between">
                    <p className="m-0">My Tickets</p>
                    <RiArrowDropDownLine
                        size={34}
                        className="dropdown-icon"
                    />
                </div>
                <div className="list-item d-flex align-items-center justify-content-between">
                    <p className="m-0">My Tasks</p>
                    <RiArrowDropDownLine
                        size={34}
                        className="dropdown-icon"
                    />
                </div>
            </div>
            <div className="bottom-row">
                <p className="m-0">Team Chat</p>
            </div>
        </div>
    )
}

export default RightBar;